import { render, staticRenderFns } from "./SettingsCustomDomain.vue?vue&type=template&id=6ef1c580&"
import script from "./SettingsCustomDomain.vue?vue&type=script&lang=js&"
export * from "./SettingsCustomDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports